export const translations = {
  es: {
    nav: { features: "Funciones", security: "Seguridad", waitlist: "Descargar", demo: "Probar demo", github: "GitHub" },
    hero: {
      badge: "Ya disponible en el App Store y en Google Play",
      title1: "Acepta pagos en",
      title2: "Bitcoin Lightning",
      title3: "desde tu celular",
      subtitle: "Punto de venta móvil rápido, simple y moderno. Catálogo táctil, cobro con QR y conversión MXN → sats en tiempo real. Solo el teléfono que ya tienes: sin comprar terminal, sin computadora en el mostrador y sin nada que instalar ni mantener.",
      ctaSecondary: "Probar demo web",
      stat1: "Confirmación",
      stat1v: "Automática",
      stat2: "Conversión",
      stat2v: "MXN → sats",
      stat3: "Disponible en",
      stat3v: "iOS · Android · Web",
    },
    appStore: {
      badgeAlt: "Descargar Lightning POS en el App Store",
      note: "Gratis · iPhone y iPad · iOS 15.1+",
    },
    googlePlay: {
      badgeAlt: "Descargar Lightning POS en Google Play",
      note: "Gratis · Android",
    },
    stores: {
      note: "Gratis · iPhone, iPad y Android · sin hardware extra",
    },
    features: {
      kicker: "Funciones principales",
      title: "Para el comercio que quiere cobrar, no configurar",
      subtitle: "Selecciona productos, cobra, confirma el pago y registra la venta en segundos.",
      items: [
        { title: "Catálogo táctil", desc: "Tus productos en un catálogo optimizado para uso táctil. Agrega artículos al carrito con un toque." },
        { title: "Cobro instantáneo con QR", desc: "El cliente escanea un código QR y paga en segundos. La venta se marca como pagada sola, sin que tengas que revisar nada." },
        { title: "Conversión en tiempo real", desc: "Precios en pesos mexicanos convertidos automáticamente a sats con el tipo de cambio en vivo de Bitso." },
        { title: "Varias terminales, varios cajeros", desc: "Empareja los teléfonos de tu equipo escaneando un QR. Todos cobran al mismo tiempo, contra el mismo catálogo y el mismo historial." },
      ],
    },
    security: {
      kicker: "Control del negocio",
      title: "Tú mandas en tu caja",
      subtitle: "Tu equipo cobra por ti, sin poder tocar lo que no le toca.",
      items: [
        { title: "Cada terminal con su PIN", desc: "Nadie cobra sin desbloquear. Si alguien deja el teléfono en el mostrador, no pasa nada." },
        { title: "Tu cajero cobra, no administra", desc: "Los cajeros venden y cobran, pero no ven tus reportes ni pueden borrar ventas del historial." },
        { title: "Se va un empleado, se va su terminal", desc: "Revoca cualquier terminal desde tu teléfono. Ese dispositivo deja de cobrar al instante." },
      ],
    },
    everything: {
      kicker: "Todo incluido",
      title: "Todo lo que necesitas para vender",
      subtitle: "Una solución ligera, rápida y enfocada en comercios que quieren aceptar Bitcoin sin complicaciones.",
      items: [
        { title: "Dashboard de ventas", desc: "Visualiza tus ventas del día de un vistazo." },
        { title: "Historial de transacciones", desc: "Cada cobro queda registrado y consultable." },
        { title: "Carrito táctil", desc: "Flujo de venta diseñado para pantallas móviles." },
        { title: "App instalable (PWA)", desc: "Instálala desde el navegador, funciona como app nativa." },
      ],
      note: "Lightning POS ya está en producción: la app está publicada en el App Store (iPhone y iPad) y en Google Play (Android), y el punto de venta web opera en pos.lightningnetwork.tf. Puedes probarlo sin instalar nada con el modo demostración.",
    },
    waitlist: {
      kicker: "Descarga la app",
      title: "Lightning POS ya está en el App Store y en Google Play",
      subtitle: "Descárgala gratis para iPhone, iPad o Android y empieza a cobrar en Bitcoin hoy.",
      androidNote: "¿Quieres enterarte de las nuevas funciones antes que nadie? Déjanos tu correo.",
      emailPlaceholder: "tu@correo.com",
      namePlaceholder: "Tu nombre (opcional)",
      submit: "Unirme a la lista",
      submitting: "Enviando...",
      comingSoon: "Próximamente",
      comingSoonNote: "La lista de espera estará disponible muy pronto ⚡",
      success: "¡Listo! Te avisaremos pronto ⚡",
      duplicate: "Este correo ya está en la lista.",
      error: "Ocurrió un error. Intenta de nuevo.",
      invalidEmail: "Ingresa un correo válido.",
    },
    footer: {
      tagline: "Punto de venta móvil para Bitcoin Lightning Network.",
      links: "Enlaces",
      demo: "Demo en vivo",
      rights: "Hecho con ⚡ en México.",
    },
  },
  en: {
    nav: { features: "Features", security: "Security", waitlist: "Download", demo: "Try demo", github: "GitHub" },
    hero: {
      badge: "Now on the App Store and Google Play",
      title1: "Accept",
      title2: "Bitcoin Lightning",
      title3: "payments from your phone",
      subtitle: "A fast, simple and modern mobile point of sale. Touch catalog, QR checkout and real-time MXN → sats conversion. Just the phone you already have: no terminal to buy, no computer on the counter, nothing to install or maintain.",
      ctaSecondary: "Try the web demo",
      stat1: "Confirmation",
      stat1v: "Automatic",
      stat2: "Conversion",
      stat2v: "MXN → sats",
      stat3: "Available on",
      stat3v: "iOS · Android · Web",
    },
    appStore: {
      badgeAlt: "Download Lightning POS on the App Store",
      note: "Free · iPhone and iPad · iOS 15.1+",
    },
    googlePlay: {
      badgeAlt: "Get Lightning POS on Google Play",
      note: "Free · Android",
    },
    stores: {
      note: "Free · iPhone, iPad and Android · no extra hardware",
    },
    features: {
      kicker: "Core features",
      title: "For merchants who want to sell, not configure",
      subtitle: "Pick products, charge, confirm the payment and log the sale in seconds.",
      items: [
        { title: "Touch product catalog", desc: "Your products in a catalog optimized for touch. Add items to the cart with a tap." },
        { title: "Instant QR checkout", desc: "Your customer scans a QR code and pays in seconds. The sale marks itself as paid — you don't have to check anything." },
        { title: "Real-time conversion", desc: "Prices in Mexican pesos converted automatically to sats using Bitso's live exchange rate." },
        { title: "Multiple terminals, multiple cashiers", desc: "Pair your team's phones by scanning a QR. Everyone sells at once, against the same catalog and the same history." },
      ],
    },
    security: {
      kicker: "Control of your business",
      title: "You're in charge of your register",
      subtitle: "Your team sells for you, without touching what they shouldn't.",
      items: [
        { title: "A PIN on every terminal", desc: "Nobody sells without unlocking. If someone leaves the phone on the counter, nothing happens." },
        { title: "Cashiers sell, they don't administer", desc: "Cashiers can sell and charge, but they can't see your reports or delete sales from the history." },
        { title: "Employee leaves, terminal goes", desc: "Revoke any terminal from your phone. That device stops selling instantly." },
      ],
    },
    everything: {
      kicker: "All included",
      title: "Everything you need to sell",
      subtitle: "A lightweight, fast solution for merchants who want to accept Bitcoin without the hassle.",
      items: [
        { title: "Sales dashboard", desc: "See your daily sales at a glance." },
        { title: "Transaction history", desc: "Every payment is logged and searchable." },
        { title: "Touch cart", desc: "A checkout flow designed for mobile screens." },
        { title: "Installable app (PWA)", desc: "Install from your browser, works like a native app." },
      ],
      note: "Lightning POS is live: the app is published on the App Store (iPhone and iPad) and on Google Play (Android), and the web point of sale runs at pos.lightningnetwork.tf. You can try it without installing anything using demonstration mode.",
    },
    waitlist: {
      kicker: "Download the app",
      title: "Lightning POS is on the App Store and Google Play",
      subtitle: "Get it free for iPhone, iPad or Android and start accepting Bitcoin today.",
      androidNote: "Want to hear about new features first? Leave us your email.",
      emailPlaceholder: "you@email.com",
      namePlaceholder: "Your name (optional)",
      submit: "Join the waitlist",
      submitting: "Sending...",
      comingSoon: "Coming soon",
      comingSoonNote: "The waitlist will be available very soon ⚡",
      success: "Done! We'll be in touch soon ⚡",
      duplicate: "This email is already on the list.",
      error: "Something went wrong. Try again.",
      invalidEmail: "Enter a valid email.",
    },
    footer: {
      tagline: "Mobile point of sale for the Bitcoin Lightning Network.",
      links: "Links",
      demo: "Live demo",
      rights: "Made with ⚡ in Mexico.",
    },
  },
};
